const Management = () => {
  return (
    <>
      <style>{`
        .management-section {
          padding: 80px 20px;
          background: #f8fafc;
          font-family: 'Poppins', sans-serif;
        }

        .management-container {
          max-width: 1200px;
          margin: auto;
          text-align: center;
        }

        .management-title {
          font-size: 36px;
          margin-bottom: 10px;
          color: #0f172a;
        }

        .management-subtitle {
          font-size: 16px;
          color: #64748b;
          max-width: 700px;
          margin: 0 auto 50px auto;
          line-height: 1.7;
        }

        .management-grid {
          display: grid;
          grid-template-columns: repeat(2, 1fr);
          gap: 40px;
        }

        .management-card {
          background: white;
          padding: 25px;
          border-radius: 18px;
          box-shadow: 0 15px 35px rgba(0,0,0,0.08);
          transition: 0.3s ease;
        }

        .management-card:hover {
          transform: translateY(-6px);
          box-shadow: 0 20px 45px rgba(0,0,0,0.12);
        }

        .management-card img {
          width: 160px;
          height: 160px;
          object-fit: cover;
          border-radius: 50%;
          margin-bottom: 15px;
          border: 5px solid #e2e8f0;
        }

        .management-card h3 {
          margin-bottom: 15px;
          color: #1e3a8a;
          font-size: 20px;
        }

        .management-oval {
          background: #f1f5f9;
          padding: 18px;
          border-radius: 20px;
          text-align: left;
        }

        .management-oval strong {
          display: block;
          margin-bottom: 8px;
          color: #0f172a;
        }

        .management-oval p {
          font-size: 14px;
          color: #475569;
          line-height: 1.7;
        }

        /* ---------- Tablet ---------- */
        @media (max-width: 1024px) {
          .management-grid {
            grid-template-columns: 1fr;
            gap: 35px;
          }

          .management-title {
            font-size: 30px;
          }
        }

        /* ---------- Mobile ---------- */
        @media (max-width: 600px) {
          .management-section {
            padding: 60px 15px;
          }

          .management-title {
            font-size: 24px;
          }

          .management-subtitle {
            font-size: 14px;
            margin-bottom: 35px;
          }

          .management-card {
            padding: 20px;
          }

          .management-card img {
            width: 120px;
            height: 120px;
          }

          .management-oval {
            padding: 15px;
          }

          .management-oval p {
            font-size: 13px;
          }
        }
      `}</style>

      <section id="management" className="management-section">
        <div className="management-container">

          <h2 className="management-title">🏫 Management Desk</h2>
          <p className="management-subtitle">
            Our leadership team is committed to excellence, discipline, and holistic
            education for every student.
          </p>

          <div className="management-grid">

            {/* Chairman */}
            <div className="management-card">
              <img src="/images/chairman.jpeg" alt="Chairman" />
              <h3>Chairman</h3>

              <div className="management-oval">
                <strong>Mr. Krishna Singh Sisodiya</strong>
                <p>
                  Education is the strongest foundation of a nation. Our mission is to
                  provide value-based education that builds character, confidence,
                  and responsible citizenship in every child.
                </p>
              </div>
            </div>

            {/* Director */}
            <div className="management-card">
              <img src="/images/directore.jpeg" alt="Director" />
              <h3>Director</h3>

              <div className="management-oval">
                <strong>Mr. Jitendra Singh Sisodiya</strong>
                <p>
                  Knowledge empowers minds and shapes futures. We focus on academic
                  excellence, skill development, and all-round growth to prepare
                  students for global challenges.
                </p>
              </div>
            </div>

          </div>
        </div>
      </section>
    </>
  );
};

export default Management;
